<template>
  <div>
    <div class="k-modal-title mb-2">Укажите дни питания:</div>
    <div
      v-for="(type, index) in time_types"
      :key="index" 
      class="k-modal-sticker mb-1" 
      :class="{ selected: currentData === type.type }"
      @click="currentData = type.type"
    >
      <div class="d-flex flex-column">
        <span class="k-modal-sticker__title">{{ type.title }}</span>
        <span class="k-modal-sticker__subtitle">{{ type.subtitle }}</span>
      </div>
    </div>
    <div class="k-modal-button mt-4 mb-2" :class="{ disabled: !currentData }" @click="$emit('next')">
      Далее
    </div>
    <div class="k-modal-button" style="background: #f68c1e" v-if="$mq === 'sm' || $mq === 'xs'" @click="$emit('back')">
      Назад
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: String,
      default: '',
    }
  },
  data: () => ({
    time_types: [
      { type: 'seven_days', title: '7 дней в неделю', subtitle: 'пн-вс' },
      { type: 'five_days', title: '5 дней в неделю', subtitle: 'пн-пт' },
    ],
  }),
  computed: {
    currentData: {
      get() { return this.data },
      set(value) { this.$emit('update', value) }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>